import { SkeletonLinesComponent } from "@iventis/components";
import { styled } from "@iventis/styles";
import React, { FunctionComponent } from "react";
import { ChangeLogItemSkeltonComponent } from "./change-log-item-skeleton";

const Section = styled.div`
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    padding: 8px 0px;
`;

const Header = styled.div`
    margin-bottom: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const HeaderDivider = styled.div`
    flex: 1;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 0 8px;
`;

const ItemDivider = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 8px 0;
`;

const PaddedChangeLogItem = styled(ChangeLogItemSkeltonComponent)`
    margin: 8px 12px;
`;

export const ChangeLogSectionSkeletonComponent: FunctionComponent = () => (
    <>
        <Header>
            <HeaderDivider />
            <SkeletonLinesComponent width="120px" height="14px" />
            <HeaderDivider />
        </Header>
        <Section>
            {["s1", "s2", "s3", "s4", "s5"].map((key, index) => (
                <React.Fragment key={key}>
                    {index > 0 && <ItemDivider />}
                    <PaddedChangeLogItem />
                </React.Fragment>
            ))}
        </Section>
    </>
);
